import React, { useEffect, useState } from 'react'
import ReusableDiv from 'src/helper/ReusableDiv';
import CheckoutTotal from '../Checkout/CheckoutTotal';
import { useOrderStore } from 'src/hooks/order';
import System from 'src/helper/system';
import { __remove, __set } from 'src/store/axios_indicator';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Constants from 'src/helper/Constants';
import CheckoutOrderItemList from '../Checkout/CheckoutOrderItemList';
import Product from "@system/config/product";
import DOMAttachToSystem from 'src/captain/DOMAttachToSystem';
import Helper from 'src/helper/Helper';
import Order from "@system/config/order";
import ShowAlert from 'src/component/Global/ShowAlert';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import printIcon from "src/assets/images/print-icon.svg";
import callIcon from "src/assets/images/call-icon.svg";
import mailIcon from "src/assets/images/mail-icon.svg";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const SuccessCheckout = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { fetch_place_order_items }, { }] = useOrderStore();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [checkoutData, setCheckoutData] = useState([])
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
    const { siteUser: { CORE }, addressType: { SHIP_TO }, paymentType: { CreditCard } } = Constants
    const { storageName: { ORDER_FEEDBACK, SUCCESS_PAGE, QUOTE_CART_LIST }, avUserInfoData: { currentUser, email, accountNumber } } = System
    const isCoreUser = currentUser === CORE
    const [{ }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();

    useEffect(() => {
        const c = System.getParams();
        async function fetchHere() {
            const detail = await fetch_place_order_items(c?.orderId);
            if (detail && Object.entries(detail.payload).length > 0) {
                setCheckoutData(detail.payload);
                const itemsWithQuoteInfo = (detail?.payload?.items || []).map(item => ({
                    ...item,
                    quoteNumber: detail?.payload?.sapQuoteNumber || ''
                }));

                HelperAnalyticsEvent.quoteCartEvent({quoteCartDetails: itemsWithQuoteInfo,event: "quoteCartCheckout"});         
                // added by Ramya
                if (detail.payload) {
                    purchaseEvent(detail.payload);
                }

                // open feedback popup
                if (localStorage.getItem(ORDER_FEEDBACK)) {
                    System.popup("PlaceOrderFeedback", {})
                }
            }

            setTimeout(() => {
                __remove('CART_API_CALL', 'VIEW_CART_API_CALL')
            }, 500);
            setFirstServerCall(false)
        }

        if (sessionStorage.getItem(c.orderId)) {
            __set('CART_API_CALL', 'VIEW_CART_API_CALL'); // set same loader as like checkout total
            fetchHere()
            sessionStorage.setItem(SUCCESS_PAGE, SUCCESS_PAGE)
        } else {
            window.location.href = Order.getOrderRouteURL()
        }
        setTimeout(() => {
            sessionStorage.removeItem(c.orderId)
            sessionStorage.removeItem(QUOTE_CART_LIST)
        }, 500);
    }, []);

    const renderAddress = (addressType, showAccountNo) => {
        const _address = checkoutData.orderAddress.find(f => f.addressType === addressType);
        if (_address) {
            return (
                <div className='d-flex justify-content-between '>
                    <div>
                        <div className="font-13 font-arial">{_address.name}</div>
                        <p className='font-arial font-13'>
                            <div>{_address?.lineOne},</div>
                            {Helper.valueIsNotNull(_address?.lineTwo) && <div>{_address?.lineTwo},</div>}
                            {Helper.valueIsNotNull(_address?.cityName) ? _address?.cityName + ", " : ""}
                            {Helper.valueIsNotNull(_address?.stateName) ? _address?.stateName + ", " : ""}
                            {_address?.postalCode},<br />
                            {_address?.countryName}
                        </p>
                    </div>
                    <div>
                        {isCoreUser && showAccountNo && <p className='d-flex flex-column'><b>Shipping Account No:</b> {checkoutData?.shipToId}</p>}
                    </div>
                </div>
            )
        } else { return <></> }
    };

    useEffect(() => {
        if (checkoutData && Object.entries(checkoutData).length > 0 && document.getElementsByClassName('snippet') && document.getElementsByClassName('snippet').length > 0) {
            document.getElementsByClassName('snippet')[0].style.display = 'none';
        }
        if (firstServerCall === false && !monitorFunctionCall) {
            System.monitorJSDx()
            setMonitorFunctionCall(true)
        }
        if (checkoutData?.isFraudCheck) {
            system_alert_indicator({
                name: 'SuccessCheckout',
                message: "Your <b>&apos;Order&apos;</b> is under review. We will contact you if we need further information.",
                type: "warning"
            })
        }
    }, [checkoutData])

    useEffect(() => {
        Helper.feedBackButtonScript()
    }, []);

    //By Ramya Kannan [Place order-Purchase evnet ]

    function purchaseEvent(payload) {
        let orderDetail = payload;
        let paymentDetails = { "total": orderDetail?.orderEstimation?.orderTotal };
        let cartData = {
            "quoteID": orderDetail?.sapQuoteNumber,
            "quoteType": "online"
        }
        let prodData = [];
        orderDetail?.items.map((data, ind) => {
            let copyObj = { ...data };
            copyObj.qas = get_inventory_by_id(copyObj.ItemNumber)?.inventoryQty;
            let priceVal = getPricing(data);
            copyObj.priceSource = priceVal?.priceSource;
            copyObj.unitPrice = copyObj.unitPrice || priceVal?.marketPrice;
            copyObj.subtotal = copyObj.subtotal || (priceVal?.marketPrice * priceVal?.quantity);
            prodData[ind] = copyObj;
        });
        localStorage.setItem("adobeEventType", "purchaseEvent");
        if (Object.keys(orderDetail).length && Object.keys(paymentDetails)) {
            HelperAdobeEvent.trackingAdobeEvent({ orderDetail, paymentDetails, cartData, prodData });
        }
    }

    const getPricing = (ele) => {
        let priceValues = get_pricing_by_id({ uniqueId: ele.bomDetailId ? ele.bomDetailId : ele.ItemNumber })
        return priceValues && priceValues[0];
    }

    return (
        <>
            {(checkoutData && Object.entries(checkoutData).length > 0) &&
                <>
                    {process.env.NODE_ENV !== "development" && <DOMAttachToSystem />}
                    <div className='checkout-process pt-3'>
                        <div className='container'>
                            {checkoutData?.isFraudCheck && <ShowAlert />}
                            <div className="order-placed-msg mt-3 mb-3">
                                <h2 className="text-center mt-0">
                                    <i className='orderplacetick'></i> Your Order Has Been Placed
                                </h2>
                                <div className="bs5 row">
                                    <div className="col-12">
                                        <p className='mb-2'>Thank you for shopping at Avnet. An email confirmation is on its way to: <b>{email}</b> with your order<br />
                                            information. If the email hasn’t arrived within a few minutes, please check your spam folder.</p>
                                        {checkoutData?.isFraudCheck && <p>
                                            <b className='mb-3'>Your &apos;Order&apos; is under review. We will contact you if we need further information.</b>
                                        </p>}
                                    </div>
                                </div>
                                <div className="bs5 row">
                                    <div className="col-12 col-sm-12 col-lg-6 col-xl-6">
                                        <p><b>Web Order Number:</b>
                                            <a className="text-blue" href={void (0)}
                                                onClick={() => window.location.href = Order.getOrderDetailRouteFromOrderSuccessURL({
                                                    web_order_number: checkoutData.orderId
                                                })}> {checkoutData && checkoutData.orderId}</a>
                                        </p>
                                        {checkoutData && checkoutData.purchaseOrderNumber && <p className="mb-0"><b>Purchase Order Number:</b> {checkoutData && checkoutData.purchaseOrderNumber}</p>}
                                    </div>
                                    <div className="col-12 col-sm-12 col-lg-6 col-xl-6 d-flex">
                                        <ul className="ms-auto p-0 mb-0">
                                            <li onClick={() => { window.print() }}><img className='me-2' src={printIcon} /><a>Print this page</a></li>
                                            <li><img className='me-2' src={callIcon} /><span>1-800-408-8353</span></li>
                                            <li><img className='me-2' src={mailIcon} /><a href="mailto:OnlineSupportUS@avnet.com">OnlineSupportUS@Avnet.com</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="bs5 row">
                                <div className="col-12"></div>
                                <div className="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9">
                                    <div className="checkout-steps">
                                        {/* {checkoutData.sapQuoteNumber && <QuoteInformationCheckout quoteNumber={checkoutData.sapQuoteNumber} />} */}
                                        <div className="shipping-address steps-inner mb-3 active completed">
                                            {ReusableDiv.checkoutStepTitle("1. Shipping Address")}
                                            <div className="shipping-address-detail checkbox-steps-content pt-0 pb-0">
                                                <div className="bs5 row">
                                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pt-2 pb-2">
                                                        {renderAddress(SHIP_TO, true)}
                                                    </div>
                                                    {(checkoutData?.attn || checkoutData?.telephoneNumber || checkoutData?.softwareDownloadEmail) && <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                        <div className="step-complete-show info-text h-100">
                                                            {checkoutData?.attn && <p><b>ATTN:</b> {checkoutData?.attn}</p>}
                                                            {checkoutData?.telephoneNumber && <p><b>Phone Number:</b> {checkoutData?.telephoneNumber}</p>}
                                                            {checkoutData?.softwareDownloadEmail && <p><b>Email Address for Downloadable Products:</b> {checkoutData?.softwareDownloadEmail}</p>}
                                                        </div>
                                                    </div>}
                                                </div>
                                                <hr className="mb-0 mt-0 step-complete-hide" />
                                            </div>
                                        </div>
                                        <div className="shipping-method steps-inner mb-3 active completed">
                                            {ReusableDiv.checkoutStepTitle("2. Shipping Method")}
                                            <div className="checkbox-steps-content">
                                                <div className="step-complete-show">
                                                    <div className="bs5 row">
                                                        <div className="col-12">
                                                            {(checkoutData?.softwareDownloadEmail && !checkoutData?.orderCarrier) ? <b>Order Contains only Software items.</b> :
                                                                <>
                                                                    <h3>SHIPPING METHOD OPTIONS:</h3>
                                                                    {checkoutData?.orderCarrier?.carrierType === 'FreeShip' ?
                                                                        <p className='font-13 font-arial mb-3'><strong> Free Shipping</strong></p> :
                                                                        <div className='mb-3'>
                                                                            <span className='font-13 font-arial me-5'><strong>{checkoutData?.orderCarrier?.carrierKey}</strong></span>
                                                                            <span className='font-13 font-arial'>{checkoutData?.orderCarrier?.carrierOption}</span>
                                                                        </div>
                                                                    }
                                                                </>
                                                            }
                                                            <hr />
                                                            <h3>SHIPPING PREFERENCES:</h3>
                                                            {checkoutData?.shippingPreference ?
                                                                <p className='font-13 font-arial'>Combine all items into one shipment</p>
                                                                :
                                                                <>
                                                                    <p className='font-13 font-arial'><strong> Ship items as they become available</strong></p>
                                                                    <p>Additional freight charges may apply for multiple shipments</p>
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="shipping-method steps-inner mb-3 active completed">
                                            {ReusableDiv.checkoutStepTitle("3. Payment Method")}
                                            <div className="checkbox-steps-content">
                                                <div className="step-complete-show">
                                                    <div className="bs5 row">
                                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                            <h3>PAYMENT METHOD:</h3>
                                                            <p className='mt-2'>{checkoutData?.paymentMethod === CreditCard ? 'Credit Card' : 'Avnet Credit Line / ' + accountNumber}</p>
                                                        </div>
                                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                            <div className="inv-add">
                                                                <h3>INVOICE ADDRESS:</h3>
                                                                {renderAddress(Constants.addressType.BILL_TO, false)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <CheckoutOrderItemList itemList={checkoutData.items} checkoutData={checkoutData} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                                    <CheckoutTotal isFrom="SuccessCheckout" />
                                    <button type="button" className="bs5 btn btn-primary w-100 mt-2 d-block "
                                        onClick={() => {
                                            window.location.href = Product.getProductListingPageRouteURL()
                                        }}>CONTINUE SHOPPING</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }

        </>
    );
}

export default SuccessCheckout;